<template>
  <div class="list-img-card info1-wrap">
    <div class="left-img-wrap">
      <Carousel :ListInstance="infosImg"></Carousel>
    </div>
    <div class="list-wrap">
      <div class="list-item-wrap" v-for="item in list" :key="item.id" @click="toDetail(item.id)">
        <div class="fText single-omit">{{ item.title }}</div>
        <div class="time">{{ item.publishTime }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from './Carousel.vue'
export default {
  props: {
    result: Object
  },
  data() {
    return {
      loading: false,
      infosImg: [],
      list: []
    }
  },
  components: { 
    Carousel
  },
  watch: {
    result: {
      handler() {
        Object.assign(this, this.result)
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    toDetail(id) {
      this.$emit('handleDetail', id)
    },
    setLoading(v) {
      this.loading = v
    }
  }
}
</script>
